import { render } from "./HelloWorld.vue?vue&type=template&id=25b7a154&scoped=true"
import script from "./HelloWorld.vue?vue&type=script&lang=js"
export * from "./HelloWorld.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-25b7a154"

export default script